import React, { useState } from "react";
import "./style.css";
import "../../../App.scss";
import { Button } from "@material-ui/core";

import mobileImage from "../../../utils/assests/offers_mobile.png";
import { Link, useHistory, Redirect } from "react-router-dom";
import axios from "../../../utils/http";
import { SELECT_OFFER } from "../../../utils/urls";
import Header from "../../../Common/header";
// import { Box } from "@material-ui/core";
import Box from '@mui/material/Box';

function OfferSummery() {
  const history = useHistory();
  const [error, setError] = useState("");
  const historyState: any =
    history.location.state == undefined
      ? history.push("/dashboard")
      : history.location.state;
  const offer: any = historyState?.offer;
  const product: any = historyState?.product;
  const application_id = historyState?.application_id;

  const handleProceed = () => {
    history.push("/imei-number", { application_id });
    // const remember = document.getElementById("remember") as HTMLInputElement;
    // if(remember.checked){
    //     axios
    //         .post(SELECT_OFFER, {cd_application_id: application_id, offer_id: offer.id})
    //         .then(res => {
    //             if(res.data.results){
    //                 history.push('/imei-number', {application_id})
    //             }
    //         })
    //         .catch(error => {
    //             alert(error.response.data.errors)
    //         })
    //     // return history.push('/success')
    // }
    // setError("please select the checkbox")
  };

  const handleInputChange = () => {
    setError("");
  };

  return (
    <Box className="grayCard">
      <div>
        <Header pageName="Offer Summary" />
      </div>

      <div id="offerContainer">
        <div>
          <img src={mobileImage} alt="mobile" id="myImg"></img>
        </div>

        <div id="details">
          <h5>{product.brand} {product.model_name},</h5>
          <p>{product.variant}</p>
          <p>{product.color}</p>
          <h4>&#8377;{product.max_price}</h4>
        </div>
      </div>

      <div>
        <div id="offer_fields">
          <div className="ofFlex">
            <div>Appove Amount</div>
            <div>{offer?.offer_amount}</div>
          </div>

          <div className="ofFlex">
            <div>Tenture</div>
            <div>{`${offer?.tenure} Months`}</div>
          </div>

          <div className="ofFlex">
            <div>Down Payment</div>
            <div style={{ marginLeft: "4.5rem", fontWeight: "bold" }}>
              {offer?.down_payment}
            </div>
          </div>

          <div className="ofFlex">
            <div>Processing Fee</div>
            <div>{offer?.processing_fee}</div>
          </div>

          <div className="ofFlex">
            <div>EMI Amount</div>
            <div>{offer?.emi_amount}</div>
          </div>

          <div className="ofFlex">
            <div>Advance EMI</div>
            <div>{offer?.advance_emi}</div>
          </div>

          <div className="ofFlex">
            <div>1st EMI Date</div>
            <div>2 Nov 2021</div>
          </div>
        </div>
      </div>

      {error ? <h6 className="errorMsg">{error}</h6> : ""}

      {/* <div id="paragraph">
                <div>
                    <input type="checkbox" name="remember" id="remember" style={{height:"20px",width:"20px"}} onChange={handleInputChange}/>
                </div>

                <div>
                    <p style={{marginTop:"0px"}}>
                    I have read and agrred all tearms with in the <span style={{color:"skyBlue"}}>credit line information shhet</span>
                    Provided by the Leader(s) and i hear by submit my acceptance  to the terms via the <span>Credit line Details Sheet </span>
                    and the <span style={{color:"skyBlue"}}>Payment understanding</span>
                    </p>
                </div>
                
            </div> */}

      <Box sx={{ textAlign: "center" }}>
        <Button
          variant="contained"
          color="secondary"
          className="redButton"
          onClick={handleProceed}
        >
          Proceed
        </Button>
      </Box>

      <Box sx={{ mt: 2 }}>
        <a
          onClick={() => {
            history.goBack();
          }}
          className="cancelBtn"
        >
          Cancel
        </a>
      </Box>
    </Box>
  );
}

export default OfferSummery;
